import { Global, css } from '@emotion/react';
import RcDialog, { DialogProps as RcDialogProps } from 'rc-dialog';
import React from 'react';

import { mediaQueries } from '../theme/mediaQueries';

/*
 * The rc-dialog package does not support changing "aria-label" on close button
 * so we cannot use its native props (pity).
 */
interface DialogProps {
  height?: number;
  width?: number;
  onClose: () => void;
}

export const Dialog: React.FC<DialogProps & RcDialogProps> = ({
  children,
  height,
  width,
  onClose, // do not pass event.
  ...props
}) => {
  const maskStyle = {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(24, 27, 27, 0.8)',
    zIndex: -1,
  };

  const style = {
    height,
    width,
  };

  const dialog = (
    <RcDialog maskStyle={maskStyle} style={style} visible onClose={() => onClose()} {...props}>
      {children}
    </RcDialog>
  );

  const styles = (
    <Global
      styles={css({
        '.rc-dialog-wrap': {
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
        '.rc-dialog': {
          position: 'relative',
          backgroundColor: 'white',
          boxSizing: 'border-box',
          maxHeight: 'calc(-24px + 100vh)',
          maxWidth: 'calc(-24px + 100vw)',
          [mediaQueries.S]: {
            height: '100vh !important',
            width: '100vw !important',
            maxHeight: 'initial',
            maxWidth: 'initial',
          },
        },
        '.rc-dialog-content': {
          position: 'relative',
          height: '100%',
        },
        '.rc-dialog-body': {
          height: '100%',
        },
        '.rc-dialog-close': {
          display: 'none',
        },
      })}
    />
  );

  return (
    <>
      {dialog}
      {styles}
    </>
  );
};
